import * as React from 'react';

import * as styles from './TagsWrapper.css';
import { ITagsWrapperProps } from './types';

export const TagsWrapper: React.VFC<ITagsWrapperProps> = props => {
  const { children } = props;

  return (
    <div className={styles['container']}>
      {React.Children.map(children, tag => {
        if (React.isValidElement(tag)) {
          return (
            <div key={tag.key} className={styles['tag']}>
              {tag}
            </div>
          );
        }

        return null;
      })}
    </div>
  );
};

TagsWrapper.displayName = 'TagsWrapper';
